import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/announcements/AnnouncementLogReport.jsx
// — ported as-is (generic module).
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'normal', label: 'Normal' },
  { value: 'important', label: 'Important' },
  { value: 'urgent', label: 'Urgent' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'title', label: 'Title' },
  { key: 'priority', label: 'Priority' },
  { key: 'published_at', label: 'Published' },
  { key: 'expires_at', label: 'Expires' },
  { key: 'author', label: 'Author' },
  { key: 'excerpt', label: 'Excerpt' },
];

export function AnnouncementLogReport() {
  return (
    <ReportView
      title="Announcement Log"
      description="Every announcement published, with priority, dates and author."
      endpoint="/reports/announcements/log"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
